import { css } from 'styled-components';
import { getColor } from '../mixins/colors';

export default css`
  /* #overlay-container .overlay {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 30;
    animation: 0.2s ease-in-out 0s both 1 fade-in;
    -webkit-animation: 0.2s ease-in-out 0s both 1 fade-in;
    background-color: ${getColor('overlay')};
    opacity: 1;
  } */
`;
